export function downloadCSV(data: Record<string, unknown>[], filename: string) {
  if (!data || !data.length) return;

  const headers = Array.from(
    new Set(data.reduce((acc: string[], curr) => [...acc, ...Object.keys(curr)], []))
  );

  const csvContent = [
    headers.join(','),
    ...data.map(row =>
      headers.map(fieldName => {
        let val: unknown = row[fieldName] === null || row[fieldName] === undefined ? '' : row[fieldName];
        if (typeof val === 'string') {
          let s = val.replace(/"/g, '""');
          if (s.search(/("|,|\n)/g) >= 0) s = `"${s}"`;
          val = s;
        }
        return val;
      }).join(',')
    )
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
